import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

class SlsCustomerCabinetStore {
    get cabinets(): string[] {
        return this._cabinets;
    }

    private set cabinets(value: string[]) {
        this._cabinets = value;
    }

    get cabinetsAsOption(): {value: string, label: string}[] {
        return (this.cabinets || []).map(cabinet => ({
            value: cabinet,
            label: cabinet
        }))
    }

    private _cabinets: string[] = []

    constructor() {
        makeAutoObservable(this)
    }

    reset() {
        this.cabinets = []
    }

    async load(id: string) {
        const response = await catchApi(async () => await api.sls.api.getCustomerCabinets(id))
        this.cabinets = response?.data || []
    }
}

const slsCustomerCabinetStore = new SlsCustomerCabinetStore()

export {
    slsCustomerCabinetStore
}
